export default __webpack_public_path__ + "static/media/C_wdt_c_cap_0.9f0028b3.mp3";